import VisitaControlloEcgEdit from "./components/VisitaControlloEcgEdit.vue";
import VisitaControlloEcgView from "./components/VisitaControlloEcgView.vue";
import VisitaControlloEcgList from "./components/VisitaControlloEcgList.vue";

export default {
    VisitaControlloEcgEdit,
    VisitaControlloEcgView,
    VisitaControlloEcgList,
};
